import { Component, EventEmitter, inject, Input, LOCALE_ID, OnInit, Optional, Output } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'

import { Select } from 'primeng/select'
import { StaticDropDown } from '@app/components/generic/generic'
import { DetailMode } from '@app/components/generic/generic.constants'

@Component({
  selector: 'app-activity-field',
  templateUrl: 'activity-field.component.html',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    Select,
    FormsModule,
  ],
})
export class ActivityFieldComponent implements OnInit {
  public readonly locale = inject(LOCALE_ID)

  @Input() activity?: string | null
  @Input() required: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() activityChange = new EventEmitter<string | null>()

  public activities: StaticDropDown[] = []
  public filterLabelField = 'label_en'
  protected readonly DetailMode = DetailMode

  ngOnInit (): void {
    if (this.locale === 'fr') {
      this.filterLabelField = 'label_fr'
    }

    this.activities = [
      { value: 'cash-for-work', label_en: 'Cash For Work', label_fr: 'Argent contre travail' },
      { value: 'construction', label_en: 'Construction / Rehabilitation', label_fr: 'Construction / Rehabilitation' },
      { value: 'distribution', label_en: 'Distribution', label_fr: 'Distribution' },
      { value: 'training', label_en: 'Training', label_fr: 'Formation' },
      { value: 'money', label_en: 'Money transfers', label_fr: 'Transferts monétaires' },
      { value: 'support', label_en: 'Support', label_fr: 'Subvention en cascade' },
      { value: 'planning', label_en: 'Planning', label_fr: 'Planification' },
      { value: 'evaluation', label_en: 'Evaluation', label_fr: 'Evaluation' },
      { value: 'protection', label_en: 'Protection', label_fr: 'Protection' },
      { value: 'wash-services', label_en: 'WASH Services', label_fr: 'Services WASH' },
    ]
  }
}
